import React from 'react';
import styled from 'styled-components';
import LogoBlue from '../@resources/img/LogoBlue.svg';

const LogoLink = styled.a`
    display: inline-block;
    margin-bottom: 1.5rem;
    align-self: flex-start;
`;

const Logo = styled.img`
    width: 9rem;
    display: block;
`;

export const PageCardLogo = () =>
    <LogoLink href="/">
        <Logo src={LogoBlue} />
    </LogoLink>;
